import { getIpType } from 'infra/helpers/getIpType';
import * as ipUtils from 'ip-utils';
import Yup from 'yup';

const cidrOrIp = (text?: string) =>
    Yup.string().matches(
        /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)(\/([0-9]|1[0-9]|2[0-9]|3[0-2]))?$/,
        text || 'Некорректно указан адрес',
    );

const securityGroupRuleIp = () => {
    return Yup.mixed().test({
        message: 'Введите корректный IP-адрес узла или\u00A0подсети',
        test: (value) => {
            if (!value) {
                return true;
            }

            return !!getIpType(value);
        },
    });
};

const securityGroupRulePort = () => {
    return Yup.string().test({
        message: 'Неверный формат ввода. Укажите порт или\u00A0диапазон портов',
        test: (value = '') => {
            const portRegex = /^([0-9]{1,4}|[1-5][0-9]{4}|6[0-4][0-9]{3}|65[0-4][0-9]{2}|655[0-2][0-9]|6553[0-5])(?:\s*-\s*([0-9]{1,4}|[1-5][0-9]{4}|6[0-4][0-9]{3}|65[0-4][0-9]{2}|655[0-2][0-9]|6553[0-5]))?$/;
            const all = value === 'Все порты';
            const res = value.match(portRegex);
            const onePort = res && res[1] && !res[2];
            const isRange = res && res[1] && !!res[2];
            let validRange;

            if (isRange) {
                validRange = +res[1] < +res[2];
            }

            return all || (res && onePort) || (res && isRange && validRange);
        },
    });
};

const busyPort = (ports) => {
    return Yup.number().test({
        message: 'Для данного порта уже есть правило',
        test: (value) => !ports.find((port) => port === value),
    });
};

Yup.addMethod(Yup.string, 'cidrSubnet', function() {
    return this.test({
        message: 'Некорректно введён адрес или маска',
        // when initial value is '', it is passed here as undefined for some reasone
        test: (value = '') => {
            const address = value.split('/')[0];
            const mask = +value.split('/')[1];
            return ipUtils.ip(address).isValid() && mask <= 32;
        },
    })
        .test({
            message: ({ value = '' }) => {
                const networkAddr = ipUtils.networkAddress(value);
                return `Этот адрес не является адресом подсети. Корректный адрес для данной сети - ${networkAddr}`;
            },
            test: (value = '') => {
                const address = value.split('/')[0];
                return address === ipUtils.networkAddress(value);
            },
        })
        .test({
            message: 'Слишком маленький размер сети',
            test: (value = '') => {
                const mask = +value.split('/')[1];
                return mask < 30;
            },
        })
        .test({
            message: 'Этот адрес не является приватным, выберите другой',
            test: (value = '') => {
                const address = value.split('/')[0];
                const isLocalhost = address.split('.')[0] === '127';
                return ipUtils.isPrivate(address) && !isLocalhost;
            },
        })
        .test({
            message: 'Недопустимый адрес подсети',
            test: (value = '') => {
                const [address, mask] = value.split('/');
                const ipArray = address.split('.');
                const isLinkLocal =
                    ipArray[0] === '169' && ipArray[1] === '254';
                return (
                    !isLinkLocal ||
                    (mask >= 16 &&
                        (mask <= 23 ||
                            (!ipUtils
                                .subnet('169.254.0.0/24')
                                .contains(address) &&
                                !ipUtils
                                    .subnet('169.254.255.0/24')
                                    .contains(address))))
                );
            },
        });
});

Yup.addMethod(Yup.string, 'isCidrBusy', function(arr) {
    return this.test({
        message: 'Этот адрес занят, выберите другой',
        test: (value) => {
            return !arr.includes(value);
        },
    }).test({
        message: 'Диапазон адресов пересекается с существующей подсетью',
        test: (value) => {
            return !arr.find((busyCidr) => {
                return ipUtils.subnet(value).contains(busyCidr);
            });
        },
    });
});

const ip = (text?: string) =>
    Yup.string().matches(
        /^([0-9]{1,3}\.){3}[0-9]{1,3}?$/,
        text || 'Некорректно указан адрес',
    );

const dns = () => {
    return Yup.string().test({
        message: 'Неверный формат ввода DNS',
        test: (value = '') => {
            if (value === '') return true;
            const ips = value.split('\n');
            let isIp = true;
            ips.forEach((ip) => {
                if (
                    !/^(([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])\.){3}([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])$/.test(
                        ip,
                    )
                ) {
                    isIp = false;
                }
            });

            return isIp;
        },
    });
};

const privateDnsDomainName = () => {
    return Yup.string()
        .matches(
            /^((([a-z0-9][a-z0-9-]{0,61}[a-z0-9])|([a-z0-9]{1,63}))\.)*(([a-z0-9][a-z0-9-]{0,61}[a-z0-9])|([a-z0-9]{1,63}))\.?$/,
            'Максимальная длина - 253 символа. Состоит из блоков вида "[a-z0-9-]+\\.". Максимальная длина блока - 63 символа. Блок не может начинаться и заканчиваться на "-"',
        )
        .min(2)
        .max(253);
};

const dnsName = () => {
    return Yup.string()
        .matches(
            /^[a-z0-9-]{2,63}$/,
            'Максимальная длина - 63 символа. Допустимы только цифры, латинские буквы и символ "-"',
        )
        .min(2)
        .max(63);
};

const cidrForNewNetwork = ({
    busyCidrList,
    networkFieldName,
    newNetworkValue = 'new',
}: {
    networkFieldName: string;
    newNetworkValue?: string;
    busyCidrList: string[];
}) => {
    return Yup.string().when(networkFieldName, {
        is: newNetworkValue,
        then: Yup.string()
            .cidrSubnet()
            .isCidrBusy(busyCidrList)
            .required(),
    });
};

export const NetworkValidationRules = {
    securityGroupRuleIp,
    securityGroupRulePort,
    busyPort,
    ip,
    dns,
    cidrOrIp,
    privateDnsDomainName,
    dnsName,
    cidrForNewNetwork,
};
